import { useCallback } from 'react';
import { AModal } from '../../../../components';
import { ITreatment } from '../../../../shared/interfaces';
import { useToast } from '../../../../hooks/toast';
import { patchTreatment } from '../../../../http';

interface IRefuseTreatment {
  open: boolean;
  close: () => void;
  treatment: ITreatment | null;
}

const RefuseTreatment: React.FC<IRefuseTreatment> = ({
  open,
  close,
  treatment,
}) => {
  const { addToast } = useToast();

  const handleSubmit = useCallback(async () => {
    await patchTreatment(treatment?.id, {
      approval: false,
    })
      .then(() => {
        addToast({
          type: 'info',
          title: 'Informação',
          description: `Orçamento recusado com sucesso`,
        });
        close();
      })
      .catch((error) => {
        addToast({
          type: 'error',
          title: 'Erro',
          description: error.response.data.error ?? 'Erro ao recusar.',
        });
      });
  }, [addToast, close, treatment?.id]);

  return (
    <AModal
      open={open}
      close={close}
      title="Recusar Tratamento"
      okText={'Recusar'}
      onOk={handleSubmit}
    >
      <></>
    </AModal>
  );
};

export default RefuseTreatment;
